module.exports = __webpack_public_path__ + "img/cover-4.f3f6a8c7.png";